"use client";

import S from "./index.module.scss";
import CatalogCard from "@/components/entities/catalog-card";
import { useCatalogData } from "@/views/catalog/hooks/useCatalogData";

const CatalogSection = () => {
  const { catalog } = useCatalogData();

  if (!catalog || catalog.length === 0) return null;

  return (
    <section className={S.catalog}>
      <p className={S.label}>Каталог</p>
      <h2 className={S.heading}>
        Создано, <br />
        чтобы служить <br />
        вечно
      </h2>

      <div className={S.cards}>
        {catalog.map((item, index) => (
          <CatalogCard item={item} key={index} />
        ))}
      </div>
    </section>
  );
};

export default CatalogSection;
